import News from "./News";

export default function Lead() {
    return (
        <div className="flex flex-col items-center justify-center px-[24px]">
            <div className="flex flex-col items-center justify-between ">
                <div className="xl:h-[132px] xl:text-center text-[18px] xl:text-[32px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text xl:leading-[45px] xl:w-[1069px] mt-[60px] xl:mt-[120px]">
                    Ключ Астром - система мониторинга и наблюдаемости на основе ИИ для оптимизации ваших бизнес-процессов
                </div>
                <ul className="text-left text-[#544a28] font-medium xl:font-semibold font-['Open Sans'] mt-[19px] text-[16px] xl:leading-[29px] list-disc pl-6 xl:text-[20px]">
                    <li>Находит ошибки до того, как они массово повлияют на конечных пользователей </li>
                    <li>Обеспечивает быстрое восстановление сервиса, если проблема произошла </li>
                    <li>Выявляет уязвимости в цифровом сервисе на уровне кода </li>
                </ul>
                <div className="w-full flex flex-col md:flex-row justify-center items-center lg:justify-center lg:items-center gap-2.5 lg:inline-flex mt-[20px] ">
                    <a href="/technologies" className="w-full max-w-[320px] md:w-[157px] h-11 px-2.5 bg-[#c0834d] rounded-[20px] justify-center items-center gap-2.5 inline-flex mb-[10px]">
                        <div className="text-white text-xl font-bold font-['Open Sans']">Подробнее</div>
                    </a>
                    <a href="/cases" className="w-full max-w-[320px] md:w-[157px] h-11 px-2.5 bg-gradient-to-r from-[#6082a0] to-[#e55961] rounded-[20px] justify-center items-center gap-2.5 inline-flex mb-[10px]">
                        <div className="text-white text-xl font-bold font-['Open Sans']">Кейсы</div>
                    </a>
                </div>
                <div className="mt-[20px] text-center text-[20px] xl:text-[24px] font-bold xl:font-extrabold font-['Open Sans'] text-[#D3AA86]">
                    Почему "Kлюч Астром"?
                </div>

                <ol className="xl:w-[953px] text-left text-[#544a28] text-[16px] font-medium xl:font-semibold font-['Open Sans'] list-decimal pl-5 mt-[20px] xl:text-[20px] mb-[60px] xl:mb-[0px]">
                    <li>Работает на высоконагруженных системах, обрабатывающих более 20 тыс. операций в секунду </li>
                    <li>Обеспечивает функциональность по информационной безопасности, соответствующую самым строгим стандартам</li>
                    {/* <li>Является полностью локальным решением с инди-агентом, не требующим установки дополнительных компонентов</li> */}
                    <li>Присутствует на российском рынке более 8 лет как решение, включенное в реестр отечественного ПО</li>
                    <li>Обладает более чем 15-летним опытом работы команды на рынке</li>
                    <li> Возможна SaaS или On-Premise версии </li>
                </ol>
            </div>
        </div>
    );
}